import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const StrategyFinderResultSchema = withDefaults({
  type: 'strategy-finder-result',
  objectExtensions: ['strategy-finder-result'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'chosenPlan',
    },
    {
      kind: 'attribute',
      name: 'currentPlan',
    },
    {
      kind: 'attribute',
      name: 'recommendedPlan',
    },
    {
      kind: 'hasMany',
      name: 'employees',
      type: 'employee',
      options: {
        async: false,
        inverse: 'strategyFinderResult',
      },
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default StrategyFinderResultSchema;
